<template>
  <div>
    <div>
    <HeaderBreadcrumbs :items="[
      { label: 'Item', to: '/ax/items' },
      { label: 'Edit' }
    ]" title="Edit Item" />
    <div class="flex-col w-full bg-white shadow-sm rounded-lg px-4 py-4">
      <div class="w-1/2">
        <div class="mb-3 mr-1.5">
          <h4 class="font-bold text-xl leading-7 mb-3 block">Edit Item</h4>
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Item Name
          </label>
          <multiselect
          v-model="itemSingle"
  label="name"
  track-by="item_id"
                placeholder="select item..."
                open-direction="bottom"
                :options="itemSingleSearchOptions"
                :searchable="true"
                :loading="isLoadingItemSingleSearch"
                :close-on-select="true"
                :options-limit="10"
                :multiple="false"
                @search-change="itemSingleFind"
              >
              </multiselect>
        </div>
        <div class="mb-3">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Name
          </label>
          <input id="basePrice" type="text" v-model="name" placeholder="Enter Name"
            class="w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2" />
        </div>
        <div class="mb-3">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Base Price
          </label>
          <input id="basePrice" type="number" v-model="basePrice" placeholder="Enter Base Price"
            class="w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2" />
        </div>
        <div class="mb-3">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Single ID AX
          </label>
          <input id="basePrice" type="number" v-model="single_idax" placeholder="Enter Single ID AX"
            class="w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2" />
        </div>
        <div class="mt-3 mr-1.5">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Vendor
          </label>
          <multiselect v-model="vendor" label="name" track-by="name" placeholder="type to find vendor..."
            open-direction="bottom" :options="items_vendor" :searchable="true" :loading="isLoadingSearch"
            :close-on-select="true" @search-change="findVendorName" @input="getVendorAx">
            <span slot="noResult">
              Oops! No elements found. Consider changing the search query.
            </span>
          </multiselect>
        
        </div>
        <div class="mt-3">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Vendor ID AX
          </label>
          <input id="basePrice" type="text" v-model="vendor_id_ax" placeholder="Vendor ID AX"
            class="w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2" />
        </div>
        <div class=" mt-4 mb-3 mr-0 flex justify-start">
          <button @click="editSingleAx()" class="bg-blue-600 text-white px-4 py-2 rounded-lg mr-3">Save</button>
          <button type="reset" class="bg-whit text-gray-500 border px-4 py-2 rounded-lg">
            <router-link class="text-gray-500 no-underline hover:no-underline hover:text-gray-500" size="sm"
              :to="{ path: '/ax/items' }">
              Cancel
            </router-link>
          </button>
        </div>
      </div>
    </div>
  </div>
  </div>

</template>
<script>
import { mapActions, mapState } from 'vuex';
import { AxItemPath } from '../../router/content';
import {EventBus} from '../../event-bus'
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs'

export default {
  name: 'UpdateSingleAX',
  components: {
      HeaderBreadcrumbs
  },
  data() {
    return {
      AxItemPath,
      itemSingle: [],
      itemSingleSearchOptions: [],
      name: null,
      basePrice: null,
      single_idax: null,
      vendor: [],
      items_vendor: [],
      isLoadingSearch:false,
      vendor_id_ax: '',
      item_id: null,
    };
  },
  watch: {
    successMessage: function() {
      if (!this.successMessage) return;
      EventBus.$emit('show-toast', {
            message:'Item has been updated.',
            type: 'success',
          });
      this.$router.push('/ax/items');
    },
   
    errorMessage: function() {
      if (!this.errorMessage) return;
      EventBus.$emit('show-toast', {
            message:this.errorMessage,
            type: 'error',
          });
    },
    isError: function() {
      if (!this.isError) return;
      EventBus.$emit('show-toast', {
            message:'Ops. Something went wrong !',
            type: 'error',
          });
    },
    item: function() {
      if (!this.item) return;
      this.getDataSingleAx();
    },
    itemsSingle: function () {
    if (!this.itemsSingle) return;
    this.itemSingleSearchOptions = this.itemsSingle;
},


    $route: {
      immediate: true,
      handler(to) {
        document.title =
          to.meta.title ||
          'Edit Single AX | Content Management System Ebooks Gramedia.com';
      },
    },
  },
  created: function() {
    const id = this.$route.params.id;
    this.getSingleAxById({ id });
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.ItemSoax.isLoading,
      isError: (state) => state.ItemSoax.isError,
      successMessage: (state) => state.ItemSoax.successMessage,
      errorMessage: (state) => state.ItemSoax.errorMessage,
      item: (state) => state.ItemSoax.item,
      itemsSingle: (state) => state.ebooks.items,
      isLoadingItemSingleSearch: (state) => state.ebooks.isLoading,
    }),
  },
  methods: {
    ...mapActions('ItemSoax', ['getSingleAxById', 'updateSingleAx']),
    ...mapActions('ebooks', ['searchBooks']),
    ...mapActions('vendors', ['findVendor', 'fetchVendorsById']),
    getDataSingleAx() {
      const item = this.item;
      this.name = item.name;
      this.basePrice = item.base_price;
      this.single_idax = item.single_idax;
      this.vendor = item.vendor;
      this.vendor_id_ax = item.vendor_id_ax;
      this.item_id = item.item_id;
      this.getVendorById(item.vendor_id);
      this.actionSearchEbooks(this.name);
      this.itemSingle = {
          name: item.item_name,
          item_id: item.item_id,
      };
},

getVendorAx() {
      this.fetchVendorsById(this.vendor).then((res) => {
        this.vendor_id_ax = res.data?.data?.sync_vendor?.vendor_id_ax;
      });
    },
    getVendorById(id) {
      return this.fetchVendorsById({ id }).then(
        (res) => (this.vendor = res.data.data),
      );
    },
    itemSingleFind(query) {
      if (!query) return;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.actionSearchEbooks(query);
      }, 600);
    },

    actionSearchEbooks(keyword) {
      const payload = {
        q: keyword ?? '',
        page: 1,
        limit: 50,
      };
      this.searchBooks(payload);
    },
    findVendorName(keyword) {
      if (keyword.length > 2) {
        this.isLoadingSearch = true;
        let payload = {
          q: keyword,
        };
        this.findVendor(payload)
          .then((res) => {
            this.items_vendor = res.data.data;
            this.isLoadingSearch = false;
          })
          .catch((err) => {
            this.isLoadingSearch = false;
            console.log(err);
          });
      }
    },

    editSingleAx() {
      const payload = {
        id: this.$route.params.id,
        name: this.name,
        basePrice: this.basePrice,
        single_idax: this.single_idax,
        vendorName: this.vendor.name,
        vendor_idax: this.vendor_id_ax,
        item_id: this.item_id,
      };
      this.updateSingleAx(payload);
    },
  },
};
</script>
